export default __webpack_public_path__ + "static/media/JoeFreitas.98998c9a.png";